import { forwardRef } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { zDropdown } from "@/lib/z";
import { cn } from "@/lib/cn";

/**
 * Popover — floating panel built on @radix-ui/react-popover (DESIGN-SYSTEM §5).
 * Used for filter / column-visibility poppers.
 */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export const PopoverContent = forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "start", sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      collisionPadding={8}
      style={{ zIndex: zDropdown }}
      className={cn(
        "w-72 max-w-[calc(100vw-1rem)] rounded-lg border border-border bg-bg-elevated p-4 text-fg-primary shadow-md outline-none",
        "origin-[var(--radix-popover-content-transform-origin)] transition-[opacity,transform] duration-150",
        "data-[state=open]:opacity-100 data-[state=closed]:opacity-0",
        "data-[state=open]:scale-100 data-[state=closed]:scale-95",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = "PopoverContent";
